/* src/app/home-new/tooltip-info-components/tooltip-info-cover-laminated/tooltip-info-cover-laminated.component.scss */
p {
  font-family: "Barlow Semi Condensed", sans-serif;
  font-weight: 400;
  font-size: 14px;
}
/*# sourceMappingURL=tooltip-info-cover-laminated.component-AOSAYMHD.css.map */
